import { ECheckingType } from './ECheckingType';

export const ACheckingType = [
  { value: ECheckingType.Qr, label: 'Check QR Code' },
  { value: ECheckingType.Phone, label: 'Phone' },
  { value: ECheckingType.Mail, label: 'Email' },
];
